<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết yêu cầu đánh dấu thiết bị đã bán nhưng chưa kích hoạt</h1>
      <div class="btn-group float-right">
        <template
          v-if="
            detail.status === 'NEW' &&
            dataPermission.includes('CNPS_DEVICE_REQUEST_TICKET_SA_CONFIRM')
          "
        >
          <button
            class="f12 font-medium btn btn-success mr-2"
            @click="handleConfirmAction(detail, 'SA')"
          >
            Xác nhận
          </button>
          <button
            class="f12 font-medium btn btn-danger mr-2"
            @click="handleRejectAction(detail, 'SA')"
          >
            Từ chối
          </button>
        </template>
        <template
          v-else-if="
            detail.status === 'SA_CONFIRMED' &&
            dataPermission.includes('CNPS_DEVICE_REQUEST_TICKET_APPROVE_REJECT')
          "
        >
          <button
            class="f12 font-medium btn btn-success mr-2"
            @click="handleConfirmAction(detail, 'GDV')"
          >
            Duyệt
          </button>
          <button
            class="f12 font-medium btn btn-danger mr-2"
            @click="handleRejectAction(detail, 'GDV')"
          >
            Từ chối
          </button>
        </template>

        <button class="f12 font-medium btn btn-outline-secondary" @click="backToList">
          <i class="bx bx-arrow-back"></i> Quay lại
        </button>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"></VueLoadingOverlay>

    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-body">
        <div class="row px-1">
          <!-- Thông tin chung -->
          <div class="col-md-6 mb-3">
            <div class="card h-100">
              <div class="card-header bg-white border-bottom-0 pb-0">
                <h5 class="card-title text-primary border-left-primary pl-2">Thông tin chung</h5>
              </div>
              <div class="card-body">
                <div class="form-group row mb-1 row-info">
                  <label class="col-sm-5 col-form-label text-muted">Mã yêu cầu</label>
                  <div class="col-sm-7 pt-2">{{ detail.code }}</div>
                </div>
                <div class="form-group row mb-1 row-info">
                  <label class="col-sm-5 col-form-label text-muted">Người tạo</label>
                  <div class="col-sm-7 pt-2">{{ getPersonInfo(detail.createdUser) }}</div>
                </div>
                <div class="form-group row mb-1 row-info">
                  <label class="col-sm-5 col-form-label text-muted">Người duyệt/từ chối</label>
                  <div class="col-sm-7 pt-2">{{ getPersonInfo(detail.approvedUser) }}</div>
                </div>
                <div class="form-group row mb-1 row-info">
                  <label class="col-sm-5 col-form-label text-muted">Đối tượng xuất Hóa đơn</label>
                  <div class="col-sm-7 pt-2">
                    {{
                      detail.typeExportInvoice === 'EXPORT_FOR_SALE'
                        ? 'Xuất Hóa đơn cho Sale'
                        : detail.typeExportInvoice === 'EXPORT_FOR_MERCHANT'
                          ? 'Xuất Hóa đơn cho Merchant'
                          : detail.typeExportInvoice
                    }}
                  </div>
                </div>
                <div class="form-group row mb-1 row-info">
                  <label class="col-sm-5 col-form-label text-muted">Vùng</label>
                  <div class="col-sm-7 pt-2">{{ detail.regionName }}</div>
                </div>
                <div class="form-group row mb-1 row-info">
                  <label class="col-sm-5 col-form-label text-muted">Kho đi</label>
                  <div class="col-sm-7 pt-2">{{ detail.inventoryExportName }}</div>
                </div>
                <div class="form-group row mb-1 row-info">
                  <label class="col-sm-5 col-form-label text-muted">Kho đến</label>
                  <div class="col-sm-7 pt-2">{{ detail.inventoryImportName }}</div>
                </div>
                <div class="form-group row mb-1 row-info">
                  <label class="col-sm-5 col-form-label text-muted">Trạng thái</label>
                  <div class="col-sm-7 pt-2">
                    <span class="badge" :class="getBadgeClass(detail.status)">
                      {{ detail.statusText }}
                    </span>
                  </div>
                </div>
                <div class="form-group row mb-1 row-info" v-if="detail.reasonReject">
                  <label class="col-sm-5 col-form-label text-muted">Lý do</label>
                  <div class="col-sm-7 pt-2">{{ detail.reasonReject }}</div>
                </div>
                <div class="form-group row mb-1 row-info">
                  <label class="col-sm-5 col-form-label text-muted">Ghi chú</label>
                  <div class="col-sm-7 pt-2">{{ detail.note }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Thông tin Sale/Merchant -->
          <div class="col-md-6 mb-3 pl-0">
            <div class="card h-auto">
              <div class="card-header bg-white border-bottom-0 pb-0">
                <h5 class="card-title text-primary border-left-primary pl-2">
                  {{
                    detail.typeExportInvoice === 'EXPORT_FOR_MERCHANT'
                      ? 'Thông tin Merchant'
                      : 'Thông tin Sale'
                  }}
                </h5>
              </div>
              <div class="card-body">
                <!-- Thông tin Merchant -->
                <div v-if="detail.typeExportInvoice === 'EXPORT_FOR_MERCHANT'">
                  <div class="form-group row mb-1 row-info">
                    <label class="col-sm-4 col-form-label text-muted">Tên</label>
                    <div class="col-sm-8 pt-2">
                      {{ detail.merchantName }}
                    </div>
                  </div>
                  <div class="form-group row mb-1 row-info">
                    <label class="col-sm-4 col-form-label text-muted">Email</label>
                    <div class="col-sm-8 pt-2">{{ detail.merchantEmail }}</div>
                  </div>
                  <div class="form-group row mb-1 row-info">
                    <label class="col-sm-4 col-form-label text-muted">SĐT</label>
                    <div class="col-sm-8 pt-2">{{ detail.merchantMobile }}</div>
                  </div>
                  <div class="form-group row mb-1 row-info">
                    <label class="col-sm-4 col-form-label text-muted">CCCD</label>
                    <div class="col-sm-8 pt-2">
                      {{ detail.merchantCitizenId }}
                      <div v-if="detail.merchantCitizenIdUrl">
                        <a :href="detail.merchantCitizenIdUrl" target="_blank">Xem ảnh</a>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row mb-1 row-info">
                    <label class="col-sm-4 col-form-label text-muted">Địa chỉ</label>
                    <div class="col-sm-8 pt-2">{{ detail.merchantAddress }}</div>
                  </div>
                </div>

                <!-- Thông tin Sale -->
                <div v-else-if="detail.typeExportInvoice === 'EXPORT_FOR_SALE'">
                  <div class="form-group row mb-1 row-info">
                    <label class="col-sm-4 col-form-label text-muted">Tên</label>
                    <div class="col-sm-8 pt-2">
                      {{ detail.saleName }}
                    </div>
                  </div>
                  <div class="form-group row mb-1 row-info">
                    <label class="col-sm-4 col-form-label text-muted">Email</label>
                    <div class="col-sm-8 pt-2">{{ detail.saleEmail }}</div>
                  </div>
                  <div class="form-group row mb-1 row-info">
                    <label class="col-sm-4 col-form-label text-muted">SĐT</label>
                    <div class="col-sm-8 pt-2">{{ detail.saleMobile }}</div>
                  </div>
                  <div class="form-group row mb-1 row-info">
                    <label class="col-sm-4 col-form-label text-muted">CCCD</label>
                    <div class="col-sm-8 pt-2">
                      {{ detail.saleCitizenId }}
                      <div v-if="detail.saleCitizenIdUrl">
                        <a :href="detail.saleCitizenIdUrl" target="_blank">Xem ảnh</a>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row mb-1 row-info">
                    <label class="col-sm-4 col-form-label text-muted">Địa chỉ</label>
                    <div class="col-sm-8 pt-2">{{ detail.saleAddress }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Danh sách thiết bị -->
        <div class="row mt-1 px-1">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <h5 class="mb-3">Danh sách thiết bị</h5>
                <p class="mb-2">
                  Tổng số thiết bị: <b>{{ detail.totalDevice }}</b>
                </p>
                <b-table
                  hover
                  responsive
                  :items="detail.deviceInfos || []"
                  :fields="fieldsDevice"
                  :bordered="true"
                  head-variant="light"
                >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(price)="data">
                    {{ formatPrice(data.item.price) }}
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>

        <!-- Lịch sử -->
        <div class="row mt-3 px-1">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <h5 class="mb-3 border-left-primary pl-2 text-primary">Lịch sử</h5>
                <b-table
                  hover
                  responsive
                  :items="detail.histories || []"
                  :fields="fieldsHistory"
                  :bordered="true"
                  head-variant="light"
                >
                  <template #cell(time)="data">
                    {{ data.item.dateCreate | formatDate('HH:mm DD/MM/YYYY') }}
                  </template>
                  <template #cell(user)="data">
                    <div v-if="data.item.userApprove">
                      <div>{{ data.item.userApprove.name }}</div>
                      <div v-if="data.item.userApprove.email" class="text-primary">
                        {{ data.item.userApprove.email }}
                      </div>
                    </div>
                  </template>
                  <template #cell(action)="data">
                    {{ data.item.status }}
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { DeviceService } from '@/services/device.service'
  import Config from '@/thirdParty/config'
  import mxAction from './mx-action'
  import { mapGetters } from 'vuex'

  export default {
    mixins: [mxAction],
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    data() {
      return {
        showLoading: false,
        detail: {},
        fieldsDevice: [
          { key: 'index', label: 'STT', class: 'text-center' },
          { key: 'categoryName', label: 'Tên thiết bị' },
          { key: 'serialNumber', label: 'Serial thiết bị' },
          { key: 'price', label: 'Giá thiết bị', class: 'text-right' },
        ],
        fieldsHistory: [
          { key: 'time', label: 'Thời gian', class: 'text-center' },
          { key: 'user', label: 'Người thực hiện' },
          { key: 'action', label: 'Loại hành động', class: 'text-center' },
          { key: 'description', label: 'Ghi chú' },
        ],
      }
    },
    created() {
      this.fetchData()
    },
    methods: {
      async fetchData() {
        try {
          this.showLoading = true
          const id = this.$route.params.id
          if (!id) return
          const response = await DeviceService.detailRequestTicket({ id })
          if (response.success) {
            this.detail = response.data
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      backToList() {
        this.$router.push('/device-not-yet-activated')
      },
      getPersonInfo(user) {
        if (!user) return ''
        return `${user.name} - ${user.companyCode} - ${user.typeSaleStr}`
      },
      getBadgeClass(status) {
        if (!Config.statusRequestTicket) return 'badge-secondary'
        const found = Config.statusRequestTicket.find(s => s.id === status)
        return found ? found.bgColor : 'badge-secondary'
      },
      formatPrice(value) {
        return this.formatCurrency(value)
      },
      formatCurrency(amount) {
        if (!amount) return '0 VNĐ'
        return new Intl.NumberFormat('vi-VN', {
          style: 'currency',
          currency: 'VND',
        }).format(amount)
      },
    },
  }
</script>

<style scoped>
  .border-left-primary {
    border-left: 4px solid #007bff;
  }

  .text-primary {
    color: #004085 !important;
  }

  .card {
    box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1) !important;
    border-radius: 16px !important;
    border: none !important;
  }

  .row-info {
    border-bottom: 1px dashed #e9ecef;
    margin-bottom: 10px;
    padding-bottom: 5px;
  }

  .row-info:last-child {
    border-bottom: none;
  }
</style>
